import * as React from 'react';

const FirstNotificationEndPointWidget= ({props})=> {

    return <div></div>
}

export default FirstNotificationEndPointWidget;